import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import {
  NgbActiveModal,
  NgbDateAdapter,
  NgbDateParserFormatter,
  NgbModal,
} from '@ng-bootstrap/ng-bootstrap';

import { CameraModel } from 'src/app/models/camera.model';
import { Icons } from 'src/app/models/icons.model';
import { CameraService } from 'src/app/services/camera.service';
import { ConfirmDialogComponent } from 'src/app/shared/components/confirm-dialog/confirm-dialog.component';
import { ErrorDialogComponent } from 'src/app/shared/components/error-dialog/error-dialog.component';
import {
  CustomDateAdapter,
  CustomDateParserFormatter,
} from 'src/app/shared/CustomDateParserFormatter';

@Component({
  selector: 'app-camera-editor',
  standalone: false,
  templateUrl: './camera-editor.component.html',
  styleUrls: ['./camera-editor.component.scss'],
  providers: [
    { provide: NgbDateAdapter, useClass: CustomDateAdapter },
    { provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },
  ],
})
export class CameraEditorComponent {
  isReady: boolean = true;
  cameraModel: CameraModel = new CameraModel();
  icons = new Icons();
  acsIdCopyIcon = this.icons.copy;
  macAddressCopyIcon = this.icons.copy;

  constructor(
    private modal: NgbActiveModal,
    private cameraService: CameraService,
    private modalService: NgbModal,
    private dateAdapter: NgbDateAdapter<string>
  ) { }

  cancel() {
    this.modal.dismiss();
  }

  copyAcsId() {
    navigator.clipboard.writeText(this.cameraModel.AcsId).then(() => {
      this.acsIdCopyIcon = this.icons.check;
      setTimeout(() => {
        this.acsIdCopyIcon = this.icons.copy;
      }, 2000);
    });
  }

  copyMacAddress() {
    navigator.clipboard.writeText(this.cameraModel.MacAddress).then(() => {
      this.macAddressCopyIcon = this.icons.check;
      setTimeout(() => {
        this.macAddressCopyIcon = this.icons.copy;
      }, 2000);
    });
  }

  saveCamera() {
    this.isReady = false;
    this.cameraService
      .saveCamera(this.cameraModel)
      .then((rtnval) => {
        this.modal.close(rtnval);
      })
      .catch((err) => {
        alert(err);
      });
  }

  deleteCamera() {
    const confirm = this.modalService.open(ConfirmDialogComponent, {
      keyboard: true,
    });

    confirm.componentInstance.dialogTitle = 'Delete Camera';
    confirm.componentInstance.dialogMessage =
      'Are you sure you want to delete this camera?';

    confirm.result
      .then(() => {
        this.cameraService
          .deleteCamera(this.cameraModel.Id)
          .then(() => {
            this.modal.dismiss('deleted');
          })
          .catch((err) => {
            console.log(err);
            if (err instanceof HttpErrorResponse) {
              const response = <HttpErrorResponse>err;
              const alert = this.modalService.open(ErrorDialogComponent, {
                keyboard: true,
              });
              alert.componentInstance.dialogTitle = 'Error Deleting Camera';
              alert.componentInstance.dialogMessage = response.error.Message;
              alert.result.then().catch((err) => { });
            } else {
              console.log(err);
            }
          });
      })
      .catch(() => { });
  }
}
